import React, { useState } from "react";
import { TabProps } from "./TabProps";
import { Tooltip } from "react-tooltip";
import { CheckCircleFill, CircleFill } from "react-bootstrap-icons";

const Tabs: React.FC<TabProps> = ({
  tabs,
  isCheckbox = false,
  listLength,
  tabMeasure = false,
  activeTabClass = "",
  tabLabelClass = "",
  active,
  isGreenDot = false,
  onTabClick,
}) => {
  const [activeTab, setActiveTab] = useState(active ?? 0);
  const [items, setItems] = useState(tabs);

  const setLength = () => {
    if (listLength != null) {
      tabs.map((item, index) => {
        index > listLength
          ? (item.visibility = false)
          : (item.visibility = true);
      });
    }
  };


  const handleDropdownItemsClick = (clickedItem: any) => {
    const temp = items.filter((item) => item.order !== clickedItem.order);
    let listItemOrder;
    const updatedItems = temp.map((item) => {
      if (item.visibility) {
        // If the item is currently in the list
        if (item?.order === activeTab) {
          listItemOrder = item.order;
          // Swap visibility status and set status of clickedItem to true
          return { ...item, order: clickedItem.order, visibility: false };
        }
      }
      // For other items, return as it is
      return item;
    });

    // Set the status of the clicked item to true
    const updatedClickedItem = {
      ...clickedItem,
      order: listItemOrder,
      visibility: true,
    };
    setActiveTab(updatedClickedItem?.order ?? 0);

    // Call onTabClick with the tab name and order
    if (onTabClick) {
      onTabClick(clickedItem);
    }

    // Update the items array with the updated items and clickedItem
    setItems([updatedClickedItem, ...updatedItems]);
    generateListItems();
  };

  const generateListItems = () => {
    // setLength();
    return items
      .filter((item) => item.visibility)
      .sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort by order key
      .map((item, index) => {
        if (item.hidden === true) return null;
        return (
          <li
            className={
              tabMeasure !== true ? "tab-item col-auto" : "tab-item col-auto"
            }
            key={item.order}
          >
            <div style={{ cursor: item.disabled ? "not-allowed" : "pointer" }}>
              <span
                className={`nav-link gap-3 ${
                  item.disabled ? "disabled" : ""
                } d-flex justify-content-center align-items-center${
                  item.order === activeTab ? " active-tab" : ""
                }`}
                onClick={() => {
                  if (item.disabled) return;
                  setActiveTab(item.order || 0);
                  if (onTabClick) {
                    onTabClick(item);
                  }
                }}
              >
                <div>
                {isCheckbox && (
                  <>
                    {item.order === activeTab ? (
                      <CheckCircleFill />
                    ) : (
                      <CircleFill />
                    )}
                  </>
                )}
                {item.label}
                </div>
              
                {/* GREEN DOT */}
                {isGreenDot && item.showGreenDot && (
                <div className="circle-center">
                  <div className="pulse"></div>
                  <div className="pulse pulse-delay"></div>
                </div>
             )}

              </span>
            </div>
          </li>
        );
      });
  };

  let listItems = generateListItems();

  const generateDropdownItems = () => {
    return items
      .filter((item) => !item.visibility)
      .sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort by order key
      .map((item) => (
        <li
          className="nav-item col-2"
          key={item.order}
          onClick={() => handleDropdownItemsClick(item)}
        >
          {item.label}
        </li>
      ));
  };

  let dropdownItems = generateDropdownItems();

  return (
    <div className={tabLabelClass}>
      {/* Render the tab labels */}
      <Tooltip id="my-tooltip" />
      <div>
        <div className="px-4 bg-white rounded-top">
          <ul className="nav">
            {dropdownItems.length === 0 ? (
              listItems
            ) : (
              <>
                {listItems}
                <li className="nav-item mb-0">
                  <div className="tabs-dropdown-parent">
                    <button
                      className="btn btn-secondary dropdown-toggle tabs-dropdown-element"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    ></button>

                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                    >
                      {dropdownItems.map((item, index) => item)}
                    </ul>
                  </div>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      {/* Render the content of the active tab */}
      {items.find((item) => item.order === activeTab)?.hidden !== true && (
        <div className={activeTabClass}>
          {items.find((item) => item.order === activeTab)?.content}
        </div>
      )}
    </div>
  );
};

export default Tabs;
